import { render } from "./AddOfflineBankAccountPage.vue?vue&type=template&id=234318c4&scoped=true"
import script from "./AddOfflineBankAccountPage.vue?vue&type=script&lang=js"
export * from "./AddOfflineBankAccountPage.vue?vue&type=script&lang=js"

import "./AddOfflineBankAccountPage.vue?vue&type=style&index=0&id=234318c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234318c4"]])

export default __exports__